import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "turbo-ignore",
  "description": "turbo-ignore를 사용하여 CI에서 태스크를 건너뛰는 방법을 알아봅니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "turbo를 사용하여 패키지 또는 그 의존성에 변경 사항이 있는지 확인합니다. 이는 CI에서 태스크를 빠르게 건너뛰는 데 유용할 수 있습니다."
  }, {
    "heading": "",
    "content": "자세한 내용은 다음을 참조하세요:"
  }, {
    "heading": "",
    "content": "태스크 건너뛰기 소개 가이드"
  }, {
    "heading": "",
    "content": "태스크 건너뛰기 고급 가이드"
  }, {
    "heading": "",
    "content": "npm의 turbo-ignore 문서"
  }, {
    "heading": "turbo-ignore-버전-관리",
    "content": "turbo-ignore는 저장소에 의존성을 설치하기 전에 가장 자주 사용되기 때문에 turbo-ignore를 실행할 때 사용할 수 있는 turbo 바이너리가 없습니다. 대신 turbo-ignore는 다음 전략으로 저장소에 사용할 올바른 버전을 검색합니다:"
  }, {
    "heading": "turbo-ignore-버전-관리",
    "content": "먼저, 루트 package.json#devDependencies 또는 package.json#dependencies에서 turbo 항목을 확인합니다. 버전이 발견되면 해당 버전이 사용됩니다."
  }, {
    "heading": "turbo-ignore-버전-관리",
    "content": "package.json에서 항목을 찾을 수 없는 경우, turbo.json에서 스키마를 읽습니다. the tasks 키가 발견되면 turbo@^2를 사용합니다. Turborepo v1의 pipeline이 발견되면 turbo@^1을 사용합니다."
  }],
  "headings": [{
    "id": "turbo-ignore-버전-관리",
    "content": "turbo-ignore 버전 관리"
  }]
};
export const toc = [{
  depth: 2,
  url: "#turbo-ignore-버전-관리",
  title: _jsx(_Fragment, {
    children: "turbo-ignore 버전 관리"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), "를 사용하여 패키지 또는 그 의존성에 변경 사항이 있는지 확인합니다. 이는 CI에서 태스크를 빠르게 건너뛰는 데 유용할 수 있습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " turbo-ignore"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [workspace] [flags...]"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "자세한 내용은 다음을 참조하세요:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/crafting-your-repository/constructing-ci#skipping-tasks-and-other-unnecessary-work",
          children: "태스크 건너뛰기 소개 가이드"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/guides/skipping-tasks",
          children: "태스크 건너뛰기 고급 가이드"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsxs(_components.a, {
          href: "https://www.npmjs.com/package/turbo-ignore",
          children: ["npm의 ", _jsx(_components.code, {
            children: "turbo-ignore"
          }), " 문서"]
        })
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "turbo-ignore-버전-관리",
      children: "turbo-ignore 버전 관리"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo-ignore"
      }), "는 저장소에 의존성을 설치하기 전에 가장 자주 사용되기 때문에 ", _jsx(_components.code, {
        children: "turbo-ignore"
      }), "를 실행할 때 사용할 수 있는 ", _jsx(_components.code, {
        children: "turbo"
      }), " 바이너리가 없습니다. 대신 ", _jsx(_components.code, {
        children: "turbo-ignore"
      }), "는 다음 전략으로 저장소에 사용할 올바른 버전을 검색합니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["먼저, 루트 ", _jsx(_components.code, {
          children: "package.json#devDependencies"
        }), " 또는 ", _jsx(_components.code, {
          children: "package.json#dependencies"
        }), "에서 ", _jsx(_components.code, {
          children: "turbo"
        }), " 항목을 확인합니다. 버전이 발견되면 해당 버전이 사용됩니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "package.json"
        }), "에서 항목을 찾을 수 없는 경우, ", _jsx(_components.code, {
          children: "turbo.json"
        }), "에서 스키마를 읽습니다. ", _jsxs(_components.a, {
          href: "/docs/reference/configuration#tasks",
          children: ["the ", _jsx(_components.code, {
            children: "tasks"
          }), " 키"]
        }), "가 발견되면 ", _jsx(_components.code, {
          children: "turbo@^2"
        }), "를 사용합니다. Turborepo v1의 ", _jsx(_components.code, {
          children: "pipeline"
        }), "이 발견되면 ", _jsx(_components.code, {
          children: "turbo@^1"
        }), "을 사용합니다."]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
